import type { ReactNode } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAdminRole } from '@repo/shared/common';
import { currentOrganizationQueryOptions } from '~/lib/queries/organization';
import { IpAllowlistPanel } from '~/features/settings/IpAllowlistPanel';

// Settings → Security (org IP allowlist). Admin-only management surface; the org
// + role it gates on are already warmed by the `_protected` loader.
export const Route = createFileRoute('/_protected/settings/security')({
  // Admin guard: the Security surface is admin-only. Read the (cache-warm,
  // seeded by _protected) current-org role and bounce non-admins to
  // /unauthorized. The hidden nav entry is convenience; this guard is the
  // client boundary — the API's `requireAdminAccess` gate is the real one.
  beforeLoad: async ({ context }) => {
    const { role } = await context.queryClient.ensureQueryData(
      currentOrganizationQueryOptions(),
    );
    if (role === null || !isAdminRole(role)) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: SettingsSecurityRoute,
});

function SettingsSecurityRoute(): ReactNode {
  return <IpAllowlistPanel />;
}
